/**
 * Stili condivisi per select dataset (Dashboard, Custom chart, Crash list toolbar).
 * @param {import('@mui/material').Theme} theme
 * @param {boolean} [isDark]
 */
export function getStatsPanelSelectSx(theme, isDark = false) {
  const border = isDark ? 'rgba(255, 255, 255, 0.16)' : '#e2e8f0'
  const borderHover = isDark ? 'rgba(255, 255, 255, 0.28)' : '#cbd5e1'
  const bg = isDark ? theme.palette.newColors?.gray ?? '#334155' : '#f8fafc'
  const text = isDark ? theme.palette.newColors?.lightGray ?? '#f1f5f9' : '#1e293b'

  return {
    minWidth: 200,
    maxWidth: 280,
    height: 36,
    fontSize: 14,
    fontWeight: 500,
    color: text,
    backgroundColor: bg,
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: border,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: borderHover,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
    '& .MuiSelect-select': {
      py: 0.75,
      px: 1.5,
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSvgIcon-root': {
      color: isDark ? '#cbd5e1' : '#64748b',
    },
    '&.Mui-disabled': {
      opacity: 0.72,
    },
  }
}

/** Toolbar scura DataGrid — select bianca compatta. */
export const STATS_TOOLBAR_FORM_CONTROL_SX = {
  minWidth: 280,
  color: '#0f172a',
  '& .MuiOutlinedInput-root': {
    height: 32,
    backgroundColor: '#ffffff !important',
    color: '#0f172a !important',
    fontSize: 13,
    fontWeight: 600,
    borderRadius: '8px',
    '& fieldset': {
      borderColor: '#64748b !important',
      borderWidth: 1,
    },
    '&:hover fieldset': {
      borderColor: '#334155 !important',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4f46e5 !important',
      borderWidth: 2,
    },
    '&.Mui-disabled': {
      backgroundColor: '#e2e8f0 !important',
      color: '#64748b !important',
    },
  },
  '& .MuiSelect-select': {
    py: 0.75,
    px: 1.25,
    display: 'flex',
    alignItems: 'center',
    color: '#0f172a !important',
  },
  '& .MuiSvgIcon-root': {
    color: '#334155 !important',
  },
}
